import React from 'react';
interface StatusBadgeProps {
  children: React.ReactNode;
  className?: string;
}
export function StatusBadge({
  children,
  className = ''
}: StatusBadgeProps) {
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full bg-info px-2.5 py-0.5 type-fine font-bold text-ink ${className}`} data-id="element-853" data-mp="1e6fbl5zyn93z">
      {children}
    </span>;
}